/**
 * The ruzcal management page wrapper.
 */

import { ComponentChildren } from 'preact';
import {
  IcoCalendar,
  IcoClipboard,
  IcoClock,
  IcoCog,
  IcoCube,
  IcoDocument,
  IcoSettings,
} from '@components/icons';
import { RuzcalLogo } from '@components/ruzcal';
import { useDocumentTitle } from 'client/utils/use-document-title';
import { RootNav, RootNavlink, RootPage } from '@components/root-page-layout';
import { Crumb } from '@course/components/breadcrumbs';
import { CalUserMenu } from './cal-user-menu';

type PageType =
  | 'bookings'
  | 'availability'
  | 'eventtypes'
  | 'integrations'
  | 'forms'
  | 'settings'
  | 'page-builder';

export function RuzcalMgmtPage({
  title,
  actions,
  children,
  crumbs,
  currentPage,
  hideHeader,
}: {
  title: string;
  actions?: ComponentChildren;
  crumbs?: Crumb[];
  children: ComponentChildren;
  currentPage: PageType;
  hideHeader?: boolean;
}) {
  useDocumentTitle([title]);
  return (
    <RootPage
      logo={<RuzcalLogo />}
      title={title}
      crumbs={crumbs}
      hideHeader={hideHeader}
      nav={
        <RootNav>
          <RootNavlink
            Ico={IcoDocument}
            text="Page builder"
            href="/calendar/page-builder"
            isSelected={currentPage === 'page-builder'}
          />
          <RootNavlink
            Ico={IcoCalendar}
            text="Calendar"
            href="/calendar/bookings"
            isSelected={currentPage === 'bookings'}
          />
          <RootNavlink
            Ico={IcoClock}
            text="Availability"
            href="/calendar/availability"
            isSelected={currentPage === 'availability'}
          />
          <RootNavlink
            Ico={IcoCube}
            text="Event types"
            href="/calendar/event-types"
            isSelected={currentPage === 'eventtypes'}
          />
          <RootNavlink
            Ico={IcoCog}
            text="Integrations"
            href="/calendar/integrations"
            isSelected={currentPage === 'integrations'}
          />
          <RootNavlink
            Ico={IcoClipboard}
            text="Forms"
            href="/calendar/forms"
            isSelected={currentPage === 'forms'}
          />
          <RootNavlink
            Ico={IcoSettings}
            text="Settings"
            href="/calendar/settings"
            isSelected={currentPage === 'settings'}
          />
        </RootNav>
      }
      actions={actions}
      accountMenu={<CalUserMenu />}
    >
      {children}
    </RootPage>
  );
}
